import { Component, OnInit, Inject } from '@angular/core';
import { VERSION, MatDialogRef, MatDialog, MatSnackBar, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'bil-coc-modal',
  templateUrl: './coc-modal.component.html',
  styleUrls: ['./coc-modal.component.sass']
})
export class CocModalComponent  {


  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    private dialogRef: MatDialogRef<CocModalComponent>) {
  }

  onConfirmClick(): void {
    this.dialogRef.close(true);
  }
}
